import SkeletonTimingField from './SkeletonTimingField';

interface SkeletonTimingProps {
  className?: string;
}

const SkeletonTiming = ({ className = '' }: SkeletonTimingProps) => (
  <div
    className={`grid grid-cols-1 ~gap-5/10 animate-pulse ${className}`}
    data-testid='skeleton-timing'>
    <div className='flex flex-col ~gap-4/6'>
      <SkeletonTimingField />
      <SkeletonTimingField />
      <SkeletonTimingField showClearButton />
    </div>
  </div>
);

export default SkeletonTiming;
